import toastr from "toastr";
import { translationKeyMap } from "./translationKeyMap";
import i18n from "i18n";

export const removeAcent = (alias) => {
  var str = alias;
  str = str.toLowerCase();
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  str = str.replace(
    // eslint-disable-next-line no-useless-escape
    /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
    " "
  );
  str = str.replace(/ + /g, " ");
  str = str.trim();
  return str;
};
export const alertMessage = (
  title,
  messages,
  error = false,
  isWarning = false
) => {
  toastr.options.closeButton = true;
  toastr.options.preventDuplicates = true;
  let messageError = [];
  if (error) {
    messageError = messages;
    if (isWarning) toastr.warning(messageError, title);
    else toastr.error(messageError, title);
  } else {
    toastr.success(messages, title);
  }
};

export const removeAccent = (str) => {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
};

export const buildMultipleQueryParams = (
  arrData,
  prefix,
  exQueryParams = []
) => {
  let result = [];
  if (arrData && arrData.length > 0 && prefix) {
    // eslint-disable-next-line array-callback-return
    arrData.map((value, index) => {
      result.push({ [prefix]: value });
    });
  }
  if (exQueryParams !== undefined && Array.isArray(exQueryParams)) {
    // eslint-disable-next-line array-callback-return
    exQueryParams.map((value, index) => {
      if ((arrData && arrData.length <= 0) || (arrData && arrData.length > 0)) {
        delete value[prefix];
      }
    });
    result = [...result, ...exQueryParams];
  }
  return result;
};

export const isValidComplexity = (str) => {
  let result = false;
  const re = new RegExp(
    "^(?=(.*\\d){1})(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z\\d]).{8,100}$"
  );
  if (re.test(str)) {
    result = true;
  }
  return result;
};

export const GetRoundName = (t, round) => {
  return `${t("general.roundPrefix")}${round.toString().padStart(2, "0")}`;
};

export const convertToS3Link = (s3String) => {
  // ${type}
  // ${id ? `_${id}` : ""}
  if (!s3String) return null;
  let s3StringArr = `${process.env.REACT_APP_UPLOAD_FILE_IMAGE}${s3String}`;
  return s3StringArr.replace(/ /g, "%20");
};

export function formatSecondsToMinutes(seconds) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
}

export function mapAndTranslateKey(beKey, options) {
  const mappedKey = translationKeyMap[beKey];
  return mappedKey ? i18n.t(mappedKey, options) : null;
}
